var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-control container-fluid",
      attrs: { readonly: _vm.readonly }
    },
    [
      _c("div", { staticClass: "form-check form-check-inline" }, [
        _c("label", { staticClass: "form-check-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.radioValue,
                expression: "radioValue"
              }
            ],
            staticClass: "form-check-input",
            attrs: { disabled: _vm.readonly, type: "radio", name: _vm.name },
            domProps: {
              value: _vm.valueForTrue,
              checked: _vm._q(_vm.radioValue, _vm.valueForTrue)
            },
            on: {
              change: [
                function($event) {
                  _vm.radioValue = _vm.valueForTrue
                },
                function($event) {
                  $event.preventDefault()
                  return _vm.onUpdateInput($event)
                }
              ]
            }
          }),
          _vm._v(_vm._s(_vm.textForTrue) + " ")
        ])
      ]),
      _c("div", { staticClass: "form-check form-check-inline" }, [
        _c("label", { staticClass: "form-check-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.radioValue,
                expression: "radioValue"
              }
            ],
            staticClass: "form-check-input",
            attrs: { disabled: _vm.readonly, type: "radio", name: _vm.name },
            domProps: {
              value: _vm.valueForFalse,
              checked: _vm._q(_vm.radioValue, _vm.valueForFalse)
            },
            on: {
              change: [
                function($event) {
                  _vm.radioValue = _vm.valueForFalse
                },
                function($event) {
                  $event.preventDefault()
                  return _vm.onUpdateInput($event)
                }
              ]
            }
          }),
          _vm._v(_vm._s(_vm.textForFalse) + " ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }